const getInitialUser = () => ({
    userName: "",
    stablishment: 0,
    rut: "",
    email: "",
    users_roles: [],
    role_id: "",
});
const getStoredPermissions = () => {
    const stored = window.localStorage.getItem("user_permissions");
    if (!stored)
        return [];
    try {
        return JSON.parse(stored);
    }
    catch (error) {
        console.error("Error parseando permisos de localStorage", error);
        return [];
    }
};
const moduleUserSession = {
    namespaced: true,
    state: {
        user: getInitialUser(),
        permissions: getStoredPermissions(),
    },
    getters: {
        getUser(state) {
            return state.user;
        },
        getPermissions(state) {
            return state.permissions;
        },
        hasPermission: (state) => (criteria) => {
            return state.permissions.some((p) => {
                // Validamos obligatoriamente el code
                const matchPermission = p.code === criteria.code;
                // Si viene node_id en los criterios, debe coincidir. Si no viene, se da por verdadero (true)
                const matchNode = criteria.node_id !== undefined ? p.node_id === criteria.node_id : true;
                // Si viene service_node_id, debe coincidir. Si no, se da por verdadero
                const matchServiceNode = criteria.service_node_id !== undefined ? p.service_node_id === criteria.service_node_id : true;
                const matchSubmenu = criteria.submenu_id !== undefined ? p.submenu_id === criteria.submenu_id : true;
                return matchPermission && matchNode && matchServiceNode && matchSubmenu;
            });
        },
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setPermissions(state, permissions) {
            state.permissions = permissions;
        },
        resetSession(state) {
            state.user = getInitialUser();
            state.permissions = [];
        },
    },
};
export default moduleUserSession;
